import { Grid } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ResourceApiService from '../api/ResourceApiService';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { Document, Page, pdfjs } from 'react-pdf';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import 'ckeditor5/ckeditor5.css';
import 'pdfjs-dist';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function Resource() {
    const params = useParams();
    const { t } = useTranslation();

    /**
     * @type{ResourceDto}
     */
    const [resource, setResource] = useState();
    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);

    const resourceId = params.resourceId;
    const resourceApiService = new ResourceApiService();

    const navigate = useNavigate();

    function changePage(offset) {
        setPageNumber(prevPageNumber => prevPageNumber + offset);
    }

    function previousPage() {
        changePage(-1);
    }

    function nextPage() {
        changePage(1);
    }

    function onDocumentLoadSuccess(numPages) {
        setNumPages(numPages._pdfInfo.numPages);
    }

    async function loadResource() {
        const thisResource = await resourceApiService.getResource(resourceId);

        if(thisResource.success) {
            setResource(thisResource.data);
        }
    }

    useEffect(() => {
        loadResource();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return(
        <Box>
            <Button variant={'contained'} onClick={() => navigate('/resources')} sx={{ marginTop: '10px' }}>{t('resourceDetail.returnToResources')}</Button><br/>
                <img
                    style={{ maxWidth: '100%', display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                    alt={''}
                    src={resource?.resourceImage?.url}
                />
            <Grid container columnSpacing={0.5} sx={{ marginTop: '20px' }}>
                <Grid item sx={{ marginLeft: 'auto', marginRight: 'auto' }}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: '28px', marginLeft: 'auto', marginRight: 'auto' }}>{resource?.rsTitle}</Typography>
                </Grid>
                <br/><br/>
                <Grid container item xs={12} direction={'column'} sx={{
                    marginRight: '10px',
                    width: '66%',
                    height: '100%',
                }}>
                    <div className={'ck-content content'} style={{ width: '60%', marginLeft: 'auto', marginRight: 'auto' }} dangerouslySetInnerHTML={{ __html: resource?.rsContent.replace('<figure class="media">', '') }}/>
                </Grid>
                {resource?.resourceAttachment &&
                    <Grid direction={'column'} container item xs={10} sx={{ marginLeft: 'auto', marginRight: 'auto' }}>
                        {resource.resourceAttachment.fileName.includes('.pdf') &&
                            <center>
                                <div style={{ width: '50%' }}>
                                    <Document file={resource.resourceAttachment.url}
                                              onLoadSuccess={onDocumentLoadSuccess} style={{ width: '50%' }}>
                                        <Page pageNumber={pageNumber} renderTextLayer={false}
                                              renderAnnotationLayer={false}/>
                                    </Document>
                                    <div>
                                        <p>
                                            {t('resourceDetail.pageOf', { current: pageNumber || (numPages ? 1 : '--'), total: numPages || '--' })}
                                        </p>
                                        <button
                                            type={'button'}
                                            disabled={pageNumber <= 1}
                                            onClick={previousPage}
                                        >
                                            {t('resourceDetail.previous')}
                                        </button>
                                        <button
                                            type={'button'}
                                            disabled={pageNumber >= numPages}
                                            onClick={nextPage}
                                        >
                                            {t('resourceDetail.next')}
                                        </button>
                                    </div>
                                </div>
                            </center>
                        }
                        {!resource.resourceAttachment.fileName.includes('.pdf') &&
                            <img
                                alt={''}
                                src={resource.resourceAttachment.url}
                            />
                        }
                    </Grid>}
            </Grid>
        </Box>

    )
}
